import React from 'react';
import { Paper, Skeleton, Box } from '@mui/material';

const BusinessOwnerSkeleton = () => (
  <Paper variant='outlined' sx={{ p: 2, textAlign: 'center', border: 'none' }}>
    <Skeleton variant="circular" width={80} height={80} sx={{ mx: 'auto', mb: 2 }} />
    <Skeleton variant="text" width={120} sx={{ mx: 'auto' }} />
    <Skeleton variant="text" width={100} sx={{ mx: 'auto' }} />
    <Box sx={{ mt: 2 }}>
      {[1, 2, 3].map((item) => (
        <Skeleton key={item} variant="text" />
      ))}
    </Box>
  </Paper>
);

export default BusinessOwnerSkeleton;